import { styled } from "@mui/material/styles";

import { MarketPlaceMinPrice } from "../../components/MarketPlaceMinPrice";
import { ProductV2Props } from "./ProductFullV2";

type ProductMobileStickyFooterProps = Pick<ProductV2Props, "minPrice" | "guidePriceType" | "availability">;
export const ProductMobileStickyFooter = ({
    minPrice,
    guidePriceType,
    availability,
}: ProductMobileStickyFooterProps) => {
    return (
        <MobilePriceAndAvailability>
            {minPrice && <MobileMarketPlaceMinPrice minPrice={minPrice} priceType={guidePriceType ?? undefined} />}
            {availability}
        </MobilePriceAndAvailability>
    );
};

const MobileMarketPlaceMinPrice = styled(MarketPlaceMinPrice)({
    display: "flex",
    alignItems: "center",
});

const MobilePriceAndAvailability = styled("div")(({ theme }) => ({
    display: "grid",
    gridTemplateColumns: "auto max-content",
    position: "sticky",
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.white,
    padding: `${theme.spacing(3)} ${theme.spacing(2)}`,
    gap: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.border.subtle}`,
    [theme.breakpoints.up("sm")]: {
        display: "none",
    },
}));
